import React from "react";

const OptionalPrivacyTerms = () => {
  return (
    <div className="content">
      <p>
        주식회사 아이나비시스템즈는 INAVI Maps 서비스를 이용함에 있어, 원활한 서비스
        이용 및 편리하고 유익한 정보를 제공하기 위하여 아래와 같이 개인정보를
        수집합니다.
      </p>
      <p>
        (선택정보 사항에 대해서는 동의하지 않으셔도 회사의 서비스를 이용하실 수
        있습니다.)
      </p>
      <table>
        <tbody>
          <tr>
            <td width="141">
              <p>
                <strong>수집/이용 목적</strong>
              </p>
            </td>
            <td width="312">
              <p>
                <strong>개인정보 항목</strong>
              </p>
            </td>
            <td width="148">
              <p>
                <strong>보유기간</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>회원가입 및 고객식별</p>
            </td>
            <td width="312">
              <p>① 개인회원 : 닉네임</p>
              <p>② 사업자회원 : 회원 정보(닉네임), 담당자 정보(부서, 직책)</p>
            </td>
            <td rowSpan="2" width="148">
              <p>
                서비스의 이용 종료 시 까지 보유하며, 관련수집항목의 경우 INAVI Maps
                서비스 탈퇴 시 지체 없이 파기됨.
              </p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>1:1 문의</p>
            </td>
            <td width="312">
              <p>부서, 직책</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default OptionalPrivacyTerms;
